export default __webpack_public_path__ + "static/what-we-do-software-d8cdbae06131cbdf3501b18813c71658.jpg";